// AUTH actions
const auth_types = {

  VALIDATE_TOKEN: {
    request: "VALIDATE_TOKEN_REQUEST",
    success: "VALIDATE_TOKEN_SUCCESS",
    failure: "VALIDATE_TOKEN_FAILURE"
  },

  CONFIRM: {
    request: "CONFIRM_REQUEST",
    success: "CONFIRM_SUCCESS",
    failure: "CONFIRM_FAILURE"
  },

  LOGIN: {
    request: "LOGIN_REQUEST",
    success: "LOGIN_SUCCESS",
    failure: "LOGIN_FAILURE"
  },

  LOGOUT: {
    request: "LOGOUT_REQUEST",
    success: "LOGOUT_SUCCESS",
    failure: "LOGOUT_FAILURE",
    force: "FORCE_LOGOUT"
  },

  REQUEST_PASSWORD: {
    request: "REQUEST_PASSWORD_REQUEST",
    success: "REQUEST_PASSWORD_SUCCESS",
    failure: "REQUEST_PASSWORD_FAILURE",
    reset: "REQUEST_PASSWORD_RESET"
  },

  RESET_PASSWORD: {
    request: "RESET_PASSWORD_REQUEST",
    success: "RESET_PASSWORD_SUCCESS",
    failure: "RESET_PASSWORD_FAILURE",
    reset: "RESET_PASSWORD_RESET",
    error: "RESET_PASSWORD_ERROR"
  },

  set_current_user: "SET_CURRENT_USER"

}

export default auth_types



// WEBPACK FOOTER //
// ./src/js/constants/authTypes.js